import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgEdit = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M17.5 1.115A3.808 3.808 0 0 1 22.886 6.5h-.001l-1.629 1.635a1.12 1.12 0 0 1-.318.32l-8.785 8.816c-.21.21-.495.329-.793.329H7.52a1.12 1.12 0 0 1-1.12-1.12v-3.84c0-.298.119-.583.33-.793l8.816-8.785a1.122 1.122 0 0 1 .319-.318l1.634-1.629Zm-1.006 4.164L8.64 13.105v2.255h2.255l7.826-7.854-2.227-2.227Zm3.808.64-2.22-2.221 1-.997.001-.002a1.568 1.568 0 1 1 2.218 2.218l.792.792-.794-.79-.997 1Zm-19.224.279A3.68 3.68 0 0 1 3.68 5.12h1.28a1.12 1.12 0 1 1 0 2.24H3.68A1.44 1.44 0 0 0 2.24 8.8v11.52a1.44 1.44 0 0 0 1.44 1.44H15.2a1.44 1.44 0 0 0 1.44-1.44v-1.28a1.12 1.12 0 0 1 2.24 0v1.28A3.68 3.68 0 0 1 15.2 24H3.68A3.68 3.68 0 0 1 0 20.32V8.8a3.68 3.68 0 0 1 1.078-2.602Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgEdit);
export default ForwardRef;
